import { makeStyles } from 'tss-react/mui'
import { Theme } from '@mui/material'

export const useStyles = makeStyles()((theme: Theme) => ({
  formWidth: {
    width: '20%',
    minWidth: '135px',
  },
  textField: {
    marginLeft: theme.spacing(3),
    minWidth: '135px',
    width: '30%',
    '& .Mui-disabled': {
      color: theme.palette.labraText.primary,
      '-webkit-text-fill-color': `${theme.palette.labraText.primary} !important`,
    },
  },
  selectField: {
    '& .MuiInputBase-input': {
      fontSize: '13px',
      color: theme.palette.black.main,
      textAlign: 'left',
    },
    '& .MuiInputLabel-root': {
      fontSize: '13px',
      color: theme.palette.primary.light,
      fontWeight: 600,
    },
    '& .MuiFormHelperText-root.Mui-error': {
      fontSize: '11px',
    },
    '& .MuiFormLabel-asterisk.MuiInputLabel-asterisk': {
      color: theme.palette.requiredAsterisk.main,
    },
    '& .Mui-disabled': {
      color: theme.palette.labraText.primary,
      '-webkit-text-fill-color': `${theme.palette.labraText.primary} !important`,
    },
  },
  menuRoot: {
    '&.MuiMenuItem-root': {
      fontSize: '13px',
      color: theme.palette.headerTitle.main,
    },
    '&.MuiListItem-gutters': {
      padding: theme.spacing(1.5),
    },
    '&.MuiListItem-root.Mui-selected': {
      backgroundColor: theme.palette.selectionBackgroundColor.main,
    },
    '&.MuiListItem-button:hover': {
      backgroundColor: theme.palette.selectionBackgroundColor.main,
    },
  },
  inputLabel: {
    '&.MuiFormLabel-root': {
      fontSize: '13px',
      color: theme.palette.primary.light,
      fontWeight: 600,
    },
  },
  icon: {
    '&.MuiSelect-icon': {
      color: theme.palette.text.tertiary,
    },
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: theme.spacing(1, 0),
  },
  closeIcon: {
    '&.MuiSvgIcon-root': {
      width: '20px',
      height: '20px',
      color: theme.palette.icon.main,
    },
  },
  iconButton: {
    padding: theme.spacing(0),
    margin: theme.spacing(0, 0, -3, 2.812),
  },
  description: {
    marginLeft: theme.spacing(3),
    width: '30%',
    minWidth: '135px',
  },
  quantityFieldContainer: {
    display: 'flex',
    justifyContent: 'row',
    flex: 1,
    minWidth: '300px',
    width: '50%',
  },
  priceFieldsWidthAndSpacing: {
    marginRight: '10px',
  },
}))
